import { render } from "./FaqManageCreatePage.vue?vue&type=template&id=2b0f5044&lang=true"
import script from "./FaqManageCreatePage.vue?vue&type=script&lang=js"
export * from "./FaqManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__